"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerSectionColumnsSettingsState = exports.ApplyStyleCommandState = exports.IntervalCommandStateEx = exports.IntervalCommandState = exports.SimpleCommandState = void 0;
var tslib_1 = require("tslib");
var SimpleCommandState = (function () {
    function SimpleCommandState(enabled, value) {
        this.visible = true;
        this.denyUpdateValue = false;
        this.enabled = enabled;
        this.value = value;
    }
    return SimpleCommandState;
}());
exports.SimpleCommandState = SimpleCommandState;
var IntervalCommandState = (function (_super) {
    tslib_1.__extends(IntervalCommandState, _super);
    function IntervalCommandState(enabled, interval, value) {
        var _this = _super.call(this, enabled, value) || this;
        _this.interval = interval;
        return _this;
    }
    return IntervalCommandState;
}(SimpleCommandState));
exports.IntervalCommandState = IntervalCommandState;
var IntervalCommandStateEx = (function (_super) {
    tslib_1.__extends(IntervalCommandStateEx, _super);
    function IntervalCommandStateEx(enabled, intervals, value) {
        var _this = _super.call(this, enabled, value) || this;
        _this.intervals = intervals;
        return _this;
    }
    return IntervalCommandStateEx;
}(SimpleCommandState));
exports.IntervalCommandStateEx = IntervalCommandStateEx;
var ApplyStyleCommandState = (function () {
    function ApplyStyleCommandState(commandEnabled, paragraphStyleChangeEnabled, characterStyleChangeEnabled, interval, value) {
        this.commandEnabled = commandEnabled;
        this.paragraphStyleChangeEnabled = paragraphStyleChangeEnabled;
        this.characterStyleChangeEnabled = characterStyleChangeEnabled;
        this.interval = interval;
        this.visible = true;
        this.denyUpdateValue = false;
        this.value = value;
    }
    Object.defineProperty(ApplyStyleCommandState.prototype, "enabled", {
        get: function () {
            return this.commandEnabled && (this.paragraphStyleChangeEnabled || this.characterStyleChangeEnabled);
        },
        enumerable: false,
        configurable: true
    });
    return ApplyStyleCommandState;
}());
exports.ApplyStyleCommandState = ApplyStyleCommandState;
var RulerSectionColumnsSettingsState = (function (_super) {
    tslib_1.__extends(RulerSectionColumnsSettingsState, _super);
    function RulerSectionColumnsSettingsState(enabled, interval, columns, equalWidth, activeIndex) {
        var _this = _super.call(this, enabled, interval, columns) || this;
        _this.equalWidth = equalWidth;
        _this.activeIndex = activeIndex;
        return _this;
    }
    return RulerSectionColumnsSettingsState;
}(IntervalCommandState));
exports.RulerSectionColumnsSettingsState = RulerSectionColumnsSettingsState;
